export const CatalogContext = React.createContext({});

export const CatalogDispatchContext = React.createContext(null);

export function CatalogProvider({children}) {
    const [cart, dispatch] = React.useReducer(
        catalogReducer,
        initialCart
    )
    return (
        <CatalogContext.Provider value={cart}>
            <CatalogDispatchContext.Provider value={dispatch}>
                {children}
            </CatalogDispatchContext.Provider>
        </CatalogContext.Provider>
    )
}

export function useCatalog(){
    return React.useContext(CatalogContext);
}

export function useCatalogDispatch() {
    return React.useContext(CatalogDispatchContext);
}

function catalogReducer(catalog, action){
    switch(action.type){
        case 'check': 
            return catalog.find((product) => product.key === action.key)
        default:
            throw Error("Unknown action:" + action.type);
    }
}

const initialCart = {};


const initialSubscription = {
    subscription: {}
};

export const SubscriptionContext = React.createContext({});

export const SubscriptionDispatchContext = React.createContext(null);

export function SubscriptionProvider({children}) {
    const [subscription, dispatch] = React.useReducer(
        subscriptionReducer,
        initialSubscription
    )
    return (
        <SubscriptionContext.Provider value={subscription}>
            <SubscriptionDispatchContext.Provider value={dispatch}>
                {children}
            </SubscriptionDispatchContext.Provider>
        </SubscriptionContext.Provider>
    )
}

export function useSubscription(){
    return React.useContext(SubscriptionContext);
}

export function useSubscriptionDispatch() {
    return React.useContext(SubscriptionDispatchContext);
}

function subscriptionReducer(subscription, action){
    switch(action.type){
        case 'update': 
            return {...subscription, subscription: action.payload}
        default:
            throw Error("Unknown action:" + action.type);
    }
}